import { render, staticRenderFns } from "./WorkflowTransitionDetailOptionButton.vue?vue&type=template&id=1de9dc06&"
import script from "./WorkflowTransitionDetailOptionButton.vue?vue&type=script&lang=ts&"
export * from "./WorkflowTransitionDetailOptionButton.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowTransitionDetailOptionButton.vue?vue&type=style&index=0&id=1de9dc06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports